<script
	lang="ts"
	generics="O"
>
	import { onMount, type ComponentProps } from 'svelte'
	import Autocomplete from '@isoftdata/svelte-autocomplete'

	let {
		onMount: onMountCb,
		value = $bindable(null),
		...rest
	}: {
		onMount?: () => void
		value: O | null
	} & Omit<ComponentProps<typeof Autocomplete<O | null>>, 'value'> = $props()

	onMount(() => onMountCb?.())
</script>

<Autocomplete
	{...rest}
	bind:value
></Autocomplete>
